import BaseFormModel from './models/baseFormModel';
import ApiController from '../api/apiController';
import AppAuthController from '../app/appAuthController';
import { formErrorMessages } from './constants/formErrorMessages';

const SELECTOR = '.screen-login .ui-form';

const VALIDATION_SCHEME = {
    email: [
        {
            rule: 'required',
            errorMessage: formErrorMessages.required
        },
        {
            rule: 'email',
            errorMessage: formErrorMessages.email
        }
    ],
    password: [
        {
            rule: 'required',
            errorMessage: formErrorMessages.required
        },
        {
            validator: (value) => value.trim().length >= 8,
            errorMessage: formErrorMessages.password
        }
    ]
};

export default class LoginForm extends BaseFormModel {
    apiController;
    authController;

    constructor() {
        super();

        this.apiController = new ApiController();
        this.authController = new AppAuthController();

        this.init(SELECTOR, {
            validationScheme: VALIDATION_SCHEME,
            onSubmit: this.onSubmit
        });
    }

    async onSubmit() {
        const data = Object.fromEntries(new FormData(this.form));

        const result = await this.authController.login(data);

        return result;
    }
}
